import { upcomingRenewals } from "action/plans";
import TimelineHeader from "components/Headers/SimpleHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { getPlanWiseUsers } from "action/plans";
import { LIGHT_GRAY } from "components/CommonComponents/Constant";
import { GRAY } from "components/CommonComponents/Constant";
import CustomPagination from "components/CommonComponents/Pagination";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { cyanBlue } from "pages/TenantDetails/constants/Constants";
import { CURRENCY_SYMBOL } from "components/constants";

function UpcomingRenewals() {
  const dispatch = useDispatch();
  const planList = useSelector((state) => state.planReducer.plansTenantList);
  const data = useSelector(
    (state) => state.UpcomingRenewalsReducer.upcomingRenewals
  );
  const [searchData, setSearchData] = useState({
    name: "",
    email: "",
    planName: null,
  });
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pageNum, setPageNum] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getPlanWiseUsers(dispatch);
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);
    upcomingRenewals(dispatch, searchQuery, pageNum);
  }, [pageNum]);

  useEffect(() => {
    if (data) {
      if (data?.code === 200) {
        setError(false);
        setIsLoading(false);
      } else if (data.code) {
        setError(true);
        setIsLoading(false);
      } else {
        setError(false);
        setIsLoading(true);
      }
    } else {
      setError(false);
      setIsLoading(true);
    }
  }, [data]);

  const handleChange = (name, value) => {
    setSearchData((prev) => ({ ...prev, [name]: value || null }));
  };

  const clear = () => {
    setPageNum(1);
    setIsLoading(true);
    setSearchData({
      name: "",
      email: "",
      planName: null,
    });
    upcomingRenewals(dispatch, "", 1);
  };

  const handleSearch = () => {
    let query = [];

    for (const [key, value] of Object.entries(searchData)) {
      if (value) {
        query.push({
          field: key,
          condition: "like",
          filterValues: [value],
        });
      }
    }
    setIsLoading(true);
    setPageNum(1);
    setSearchQuery(JSON.stringify(query));
    upcomingRenewals(dispatch, JSON.stringify(query), 1);
  };

  const planOptions = planList?.data
    ?.filter((item) => item.name !== "Free Plan")
    .map((item) => ({
      value: item.name,
      label: item.name,
    }));

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsLoading(true);
      handleSearch();
    }
  };

  return (
    <>
      <TimelineHeader name="Upcoming Renewals" />
      <Container onKeyDownCapture={onKeyDown} className="mt--6" fluid>
        <Card>
          <CardBody>
            <div style={styles.filterCon}>
              <Input
                placeholder="Search Name"
                type="text"
                style={styles.input}
                name="name"
                value={searchData.name}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
              />
              <Input
                placeholder="Search Email"
                type="text"
                style={styles.input}
                name="email"
                value={searchData.email}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
              />
              <Select
                options={planOptions}
                value={
                  planOptions?.find(
                    (option) => option.value === searchData.planName
                  ) || null
                }
                onChange={(e) => {
                  handleChange("planName", e?.value);
                }}
                placeholder="Select Plan"
                isClearable
                styles={customStyles}
              />
              <Button
                onClick={() => handleSearch()}
                style={styles.btn}
                size="md"
                outline
                color="info">
                Search
              </Button>
              <Button
                onClick={() => clear()}
                style={styles.btn}
                size="md"
                outline
                color="info">
                Clear
              </Button>
            </div>
            <Row lg="12" md="12" sm="12">
              {isLoading ? (
                <div style={styles.loaderContainer}>
                  <i
                    className="fa fa-spinner fa-spin fa-2xl"
                    style={styles.loaderColor}
                  />
                </div>
              ) : error ? (
                <div style={styles.loaderContainer}>
                  <p style={styles.loaderText}>Something went wrong</p>
                </div>
              ) : (
                <>
                  {data?.data?.totalRecords ? (
                    <ToolkitProvider
                      data={
                        data?.data?.upcomingRenewals
                          ? data?.data?.upcomingRenewals
                          : []
                      }
                      key={"ID"}
                      keyField="ID"
                      columns={[
                        {
                          dataField: "ID",
                          text: "ID",
                          sort: true,
                        },
                        {
                          dataField: "firstName",
                          text: "Name",
                          sort: true,
                          formatter: (cell, row) => {
                            return `${cell} ${row.lastName}`;
                          },
                        },
                        {
                          dataField: "email",
                          text: "Email",
                          sort: true,
                        },
                        {
                          dataField: "planName",
                          text: "Plan",
                          sort: true,
                        },
                        {
                          dataField: "usdRate",
                          text: "Plan Cost",
                          sort: false,
                          formatter: (cell, row) => (
                            <span>
                               {row.currency === "INR" ? CURRENCY_SYMBOL.INR + row.inrRate : CURRENCY_SYMBOL.USD + row.usdRate}
                            </span> 
                          ),
                        },
                        {
                          dataField: "renewalDate",
                          text: "Renewal Date",
                          sort: true,
                        },
                      ]}
                      search>
                      {(props) => (
                        <div className="py-4 table-responsive">
                          <BootstrapTable
                            {...props.baseProps}
                            key={"ID"}
                            keyField="ID"
                            bootstrap4={true}
                            bordered={false}
                            // selectRow={{
                            //   onSelect: (e, isSelect, rowIndex) =>
                            //     console.log(e, isSelect, rowIndex),
                            // }}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  ) : (
                    <div style={styles.loaderContainer}>
                      <p style={styles.loaderText}>No Record Found</p>
                    </div>
                  )}
                </>
              )}
            </Row>
            <CustomPagination
              totalPages={Math.ceil(
                data?.data?.totalRecords / data?.data?.noOfRecordsPerPage
              )}
              setPageNum={setPageNum}
              activePage={pageNum}
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default UpcomingRenewals;

const styles = {
  btn: {
    margin: 0,
    height: "2.375rem",
    display: "flex",
    alignItems: "center",
  },
  filterCon: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.625rem",
  },
  input: {
    width: "10rem",
    height: "2.375rem",
  },
  loaderColor: { color: cyanBlue },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "10vh",
    width: "100%",
  },
  loaderText: {
    margin: "auto",
    fontWeight: "normal",
  },
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "10rem",
    fontSize: "0.875rem",
    borderColor: state.isFocused ? LIGHT_GRAY : LIGHT_GRAY,
    boxShadow: state.isFocused ? `0 0 0 1px ${LIGHT_GRAY}` : "none",
    "&:hover": {
      borderColor: LIGHT_GRAY,
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.875rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: GRAY,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: GRAY,
  }),
};
